import { NegotiationInteractionType } from "../../../shared/services/api/sinister/SinisterNegotiationService";

// Lista oficial passada pela equipe de operação (mesmo ticket da nota em caseStatusOptions.ts) — em
// ordem alfabética (pedido explícito, facilita achar o item no select).
export const NEGOTIATION_INTERACTION_OPTIONS: { value: NegotiationInteractionType; label: string }[] = [
	{ value: "installment_agreement", label: "Acordo Parcelado" },
	{ value: "awaiting_return", label: "Aguardando Retorno" },
	{ value: "collection_dropped", label: "Cobrança Baixada" },
	{ value: "negotiating", label: "Em negociação" },
	{ value: "forwarded_to_legal", label: "Encaminhado para o Jurídico" },
	{ value: "forwarded_to_post", label: "Encaminhado para o Pós" },
	{ value: "keys_delivered", label: "Entrega de Chaves" },
	{ value: "fraud", label: "Fraude" },
	{ value: "no_contact_case", label: "Não conseguiu contato" },
	{ value: "cash_payment", label: "Pagamento a vista (Boleto, Pix, Cartão de Crédito)" },
	{ value: "payment_at_agency", label: "Pagamento na imobiliária" },
	{ value: "keys_delivery_promise", label: "Promessa de entrega de chaves" },
	{ value: "payment_promise", label: "Promessa de Pagamento" },
	{ value: "no_agreement_possible", label: "Sem Possibilidade de acordo" },
	{ value: "finalized_without_indemnity", label: "Sinistro Finalizado sem indenização" },
	{ value: "spreadsheet_request", label: "Solicitação de Planilha" },
	{ value: "fraud_suspected", label: "Suspeita de Fraude" },
];

// Códigos aposentados pela lista oficial (não aparecem mais em NEGOTIATION_INTERACTION_OPTIONS),
// mas podem existir em interações antigas gravadas antes desta correção. Mantido só pra exibição —
// nunca usar como opção de formulário.
const LEGACY_NEGOTIATION_INTERACTION_LABELS: Record<string, string> = {
	contact_made: "Contato realizado com cliente",
	no_contact: "Não foi possível contato",
	invalid_contact: "Cliente sem contato (número/email inválido)",
	proposal_sent: "Proposta de negociação enviada",
	agreement_closed: "Acordo fechado",
	negotiation_refused: "Cliente recusou negociação",
	return_on_date: "Cliente pediu para retornar em data específica",
};

export const getNegotiationInteractionLabel = (type: NegotiationInteractionType | string): string =>
	NEGOTIATION_INTERACTION_OPTIONS.find((option) => option.value === type)?.label ?? LEGACY_NEGOTIATION_INTERACTION_LABELS[type] ?? type;
